"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopifyPromiseClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const SHOPIFY_PROMISE_URL = process.env.SHOPIFY_PROMISE_URL;
const SHOPIFY_PROMISE_BASIC_AUTH_USER = process.env.SHOPIFY_PROMISE_BASIC_AUTH_USER;
const SHOPIFY_PROMISE_BASIC_AUTH_PASSWORD = process.env.SHOPIFY_PROMISE_BASIC_AUTH_PASSWORD;
class ShopifyPromiseClient extends base_client_1.ApiBasicAuthClient {
    constructor(url = SHOPIFY_PROMISE_URL, user = SHOPIFY_PROMISE_BASIC_AUTH_USER, password = SHOPIFY_PROMISE_BASIC_AUTH_PASSWORD) {
        super({
            baseURL: `${url}/v1`,
            basicAuthUser: user,
            basicAuthPassword: password,
        });
        if (!user || !password) {
            commons_logs_1.log.warn("Missing SHOPIFY_PROMISE_BASIC_AUTH_USER and SHOPIFY_PROMISE_BASIC_AUTH_PASSWORD environment variables");
        }
    }
    async updateSkuScheduleUploadStatus(sellerId, shop, skuScheduleUpload) {
        try {
            return await this.post(`/upload-status/seller/${sellerId}/shop/${shop}`, skuScheduleUpload);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async updateDskuSchedules(sellerId, dskuSchedules) {
        try {
            return await this.post(`/product-schedules/seller/${sellerId}`, dskuSchedules);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
}
exports.ShopifyPromiseClient = ShopifyPromiseClient;
//# sourceMappingURL=ShopifyPromiseClient.js.map